import { Dimensions, Alert, Platform } from "react-native";
import Swal from "sweetalert2";
//import Swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import colors from "../constants/colors";

export function getNavigator() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('safari') != -1) {
    if (ua.indexOf('chrome') > -1) {
      return 'chrome'; //Chrome
    } else {
      return 'safari'; // Safari
    }
  }
}
export const getWidth = (width) => {
    switch (width) {
        case 'extramini':
            return "33%";
        case 'mini':
            return 130;
        case "small":
            return 190;
        case "medium":
            return 290;
        case "large":
            return Dimensions.get("window").width * .90;
        default:
            return Dimensions.get("window").width * .90;
    }
}

export const getComponentSubmissionByDefaultLabel = (defaultLabel, components, submission, section_id, position) => {
    var sub = "";
    var component = components.find((component) => component.defaultLabel == defaultLabel && component.section_id == section_id);
    if (component && submission[component.id]) {
        if ((position || position == 0)) {
            sub = submission[component.id][position] ? submission[component.id][position] : "";
        } else {
            sub = submission[component.id];
        }
    }
    //console.log("component: " + component.label + " defaultLabel: " + defaultLabel + " section_id: " + section_id, " sub: " + sub + " position: " + position + " submission: " + JSON.stringify(submission));
    return sub;
}
export const getComponent = (defaultLabel, components, section_id) => {
    var component = components.find((component) => component.defaultLabel == defaultLabel && component.section_id == section_id);
    return component;
}
export const getComponentId = (defaultLabel, components, section_id) => {
    var component = components.find((component) => component.defaultLabel == defaultLabel && component.section_id == section_id);
    return component?.id;
}
export const getComponentByanotherComponentId = (componentId, defaultLabelToFound, components) => {
    var component = components.find((component) => component.id == componentId);
    if(!component)return;
    var section = components.find((comp) => comp.type == "section" && comp.section_id == component.section_id);
    if(!section)return;
    var locationComponent = components.find((component) => component?.defaultLabel == defaultLabelToFound && component.section_id == section.section_id);
    return locationComponent;
}
export function simpleAlert(title, message, confirmTxt, icon, iconColor, close){
    Swal.fire({
        title,
        html: message, 
        confirmButtonText: confirmTxt,
        confirmButtonColor: colors.orange,
        icon,
        iconColor,
        backdrop: false,
        willClose: () => {if(close)close()}
    })
}
export function confirmationAlert(title, text, confirmTxt, cancelTxt, icon, iconColor, close, confirmation, cancel){
    Swal.fire({
        title,
        text, 
        confirmButtonText: confirmTxt,
        confirmButtonColor: colors.orange,
        showCancelButton: cancelTxt ? true : false,
        cancelButtonText: cancelTxt,
        icon,
        iconColor,
        scrollbarPadding: false,
        heightAuto: false,
        willClose: () => {if(close)close()}
    }).then((result)=>{
        if(result.isConfirmed){
            if(confirmation)confirmation();
        }else if(result.isDismissed){
            if(cancel)cancel();
        }
    })
}
export const getIosCellHeight = (width, value) => {
    var val = 1;
    //console.log("width: " + width);
    switch (width) {
        case 'extramini':
            if(value?.length >= 8){
                if(value){
                    val = calculateChars(8);
                }else if(Platform.OS == "ios")val = 1.7;
            }
        case "mini":
            if(value?.length >= 10){
                if(value){
                    val = calculateChars(10);
                }else if(Platform.OS == "ios")val = 1.6;
            }
            break;
        case "small":
            if(value?.length >= 16){
                if(value){
                    val = calculateChars(16);
                }else if(Platform.OS == "ios")val = 1.5;
            }
            break;
        case "medium":
            if(value?.length >= 25){
                if(value){
                    val = calculateChars(25);
                }else if(Platform.OS == "ios")val = 1.4;
            }
            break;
        case "large":
            if(value?.length >= 29){
                if(value){
                    val = calculateChars(29);
                }else if(Platform.OS == "ios")val = 1.3;
            }
            break;
        default: 
            if(value?.length >= 32){
                if(value){
                    val = calculateChars(32);
                }else if(Platform.OS == "ios")val = 1.5;
            }
            break;
    }
    //console.log('val: ' + val);
    return val;
}
function calculateChars(value){
    var val = (value?.length / value); 
    if(val < 1.00){
        val = 1;
    }else{
        if(value?.length % value > 0){
            val = Math.trunc(val);
            val += 1;
        }
    }

    return val;
}
export function getMinChar(width) {
    var chrs = 26;
    switch (width) {
        case "small":
            chrs = 13
            break;
        case "medium":
            break;
        case "large":
            break;
    }
    return chrs;
}
export function getFirstDiv(width) {
    var val = 19;
    switch (width) {
        case "small":
            val = 11
            break;
        case "medium":
            break;
        case "large":
            break;
    }
    return val;
}
export function getSecondDiv(width) {
    var val = 28;
    switch (width) {
        case "small":
            val = 13
            break;
        case "medium":
            val = 19
            break;
        case "large":
            val = 26;
            break;
    }
    return val;
}
export function getThirdDiv(width) {
    var val = 31;
    switch (width) {
        case "small":
            val = 13
            break;
        case "medium":
            val = 24
            break;
        case "large":
            break;
    }
    return val;
}
export function getComponentSubmit(submission, components ,defaultLabel, id, position){
    var itemComponent = components.find(component => component.id == id);
    var sub = "";
    if(itemComponent && submission){
        var valueComponent = components.find(component => component.section_id == itemComponent.section_id && component.defaultLabel == defaultLabel);
        if(valueComponent){
            if(position || position == 0) {
              sub = submission[valueComponent.id][position];
            } else {
              sub = submission[valueComponent.id];
            }
        }
    }
    return sub;
}

export function getLotCodeString(lotsSelected){
    var string = "";
    if(typeof lotsSelected == "object"){
        lotsSelected.map((lot, idx)=>{
            if(idx == 0)
            if(lotsSelected.length - 1 == idx)string += (lot?.lot ? lot?.lot : "No Lot"); else string += (lot?.lot ? lot?.lot : "No Lot"); //+ "\n";
        })
    }
    if(!string)string = "No Lot";
    return string;
}
export function getTotalSelected(lotsSelected) {
    if (!lotsSelected || typeof lotsSelected != "object") return 0;
    var total = 0;
    lotsSelected.map((lot) => {
        if (lot?.historial && !lot.isNew) {
            lot.historial.map((batch) => {
                if (!batch?.hide) {
                    total += batch?.editedAmount != undefined ? !batch.editedAmount ? 0 : parseFloat(batch.editedAmount) : parseFloat(batch.amount);
                }
            })
        } else {
            total += lot?.editedAmount != undefined ? !lot.editedAmount ? 0 : parseFloat(lot.editedAmount) : parseFloat(lot.amount);
        }
    })
    total = parseFloat(total).toFixed(3);
    return total;
}
